/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2025 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

import React from 'react'

import { Form, FormGroup, Label, Input, Row, Col } from 'reactstrap'

class YesNoKeywordValue extends React.Component
{

  handleClick(value)
  {
    this.props.setSaveButtonDisabled(false);
    this.props.setKeywordValue(value);
  }

  render()
  {
    return(
      <Form  id="yesNoKeywordValue">
        <Row>
          <Col sm={{size: 2, offset: 1}}>
            <FormGroup check className="form-check-inline">
              <Label check>
                <Input defaultChecked={this.props.yesChecked} type="radio" id="yesRadioButton" name="yesNoRadio" value="Yes" 
                  onClick={this.handleClick.bind(this, 'Yes')} autoFocus />
                Yes
              </Label>
            </FormGroup>
          </Col>
          <Col>
            <FormGroup check className="form-check-inline">
              <Label check>
                <Input defaultChecked={this.props.noChecked} type="radio" id="noRadioButton" name="yesNoRadio" value="No" 
                  onClick={this.handleClick.bind(this, 'No')} />
                No
              </Label>
            </FormGroup>
          </Col>
        </Row>
      </Form>      
    )
  }
}

export default YesNoKeywordValue
